import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { XmlParser } from '@iupics-manager/managers/xml-parser/xml-parser';
import { TranslateModule } from '@ngx-translate/core';
import { EditorDestroyEvent, EditorReadyEvent, MonacoEditorComponent } from '../monaco-editor/monaco-editor.component';
import { MonacoEditorService } from '../monaco-editor/monaco-editor.service';
@Component({
  selector: 'iu-xml-viewer',
  templateUrl: './xml-viewer.component.html',
  styleUrls: ['./xml-viewer.component.scss'],
  standalone: true,
  imports: [TranslateModule, MonacoEditorComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export default class XmlViewerComponent {
  readonly #xmlParser = inject(XmlParser);
  #editorService: MonacoEditorService;

  blob = input<Blob>();

  onEditorReady(e: EditorReadyEvent): void {
    this.#editorService = e.service;
    if (this.blob()) {
      const blob = this.blob();
      this.#xmlParser.readBlobAsText(blob).subscribe((content) => {
        this.#editorService.setContent(this.#xmlParser.prettify(content));
      });
    }
  }

  onEditorDestroy(e: EditorDestroyEvent): void {
    this.#editorService = undefined;
  }
}
